import { createStore, applyMiddleware, combineReducers } from 'redux';
import { createLogger } from 'redux-logger';
import thunk from 'redux-thunk';
import clientMiddleware from './middlewares/clientMiddleware';
import notificationMiddleware from './middlewares/notificationMiddleware';
// reducers
import auth, { LOGOUT_SUCCESS } from './modules/auth';
import userReducer from './modules/user';
import cmtplCalculator from './modules/cmtplCalculator';
import vmtplReducer from './modules/vmtplCalculation';
import contractValidationReducer from './modules/contractValidation';
import cascoReducer from './modules/cascoCalculation';
import paymentsReducer from './modules/paymentsList';
import vehiclesReducer from './modules/vehicles';
import insurances from './modules/insurances';
import contract from './modules/contract';
import travelCalculation from './modules/travelCalculation';
import propertyCalculator from './modules/propertyCalculator';
import paymentReducer from './modules/payment';
import countriesReducer from './modules/countries';
import notification from './modules/notification';
import loginBlock from './modules/loginBlock';
import travelContract from './modules/travelContract';
import propertyContract from './modules/propertyContract';
import basketReducer from './modules/basketReducer';
import recPayment from './modules/recPayment';
import travelDestinations from './modules/travelDestinations';
import claim from './modules/claim';
import claimApplication from './modules/claimApplication';
import cmtplForm from './modules/cmtplForm';
import cascoClaim from './modules/cascoClaim';
import searchApplicant from './modules/searchApplicant';
import carMarks from './modules/carMarks';
import cmtplAdresses from './modules/cmtplAdresses';
import personalClaim from './modules/personalClaim';
import medicalClaim from './modules/medicalClaim';
import travelClaim from './modules/travelClaim';
import accidentClaim from './modules/accidentClaim';
import currenciesReducer from './modules/currencies';
import propertyClaim from './modules/propertyClaim';
import cmtplContract from './modules/cmtplContract';
import paymentFrequency from './modules/paymentFrequency';
import global from './modules/global';
import contractSubscription from './modules/contractSubsription';
import oncoCareContract from './modules/oncoCareContract';
import oncoCareCalculation from './modules/oncoCareCalculation';

const loggerMiddleware = createLogger(); // initialize logger

const productionMiddleware = [
  clientMiddleware(),
  notificationMiddleware(),
  thunk,
];

const devMiddleware = [...productionMiddleware, loggerMiddleware];

const middleware = process.env.NODE_ENV === 'production' ? productionMiddleware : devMiddleware;

const createStoreWithMiddleware = applyMiddleware(...middleware)(createStore);
const reducer = combineReducers({
  auth,
  userReducer,
  vmtplReducer,
  contractValidationReducer,
  cascoReducer,
  paymentsReducer,
  vehiclesReducer,
  insurances,
  contract,
  travelCalculation,
  propertyCalculator,
  cmtplCalculator,
  paymentReducer,
  countriesReducer,
  notification,
  loginBlock,
  travelContract,
  propertyContract,
  recPayment,
  basketReducer,
  travelDestinations,
  claim,
  claimApplication,
  cmtplForm,
  cascoClaim,
  searchApplicant,
  carMarks,
  cmtplAdresses,
  personalClaim,
  medicalClaim,
  travelClaim,
  accidentClaim,
  currenciesReducer,
  propertyClaim,
  cmtplContract,
  paymentFrequency,
  global,
  contractSubscription,
  oncoCareContract,
  oncoCareCalculation,
});

const rootReducer = (state, action) => {
  let newState = state;

  if (action.type === LOGOUT_SUCCESS) {
    newState = undefined;

    window.location = '/';
  }

  return reducer(newState, action);
};

const configureStore = (initialState) => createStoreWithMiddleware(rootReducer, initialState);

export default configureStore;
